import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import FloatingActions from "@/components/site/FloatingActions";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import PackagesPage from "@/pages/PackagesPage";
import PackageDetailPage from "@/pages/PackageDetailPage";
import BookingPage from "@/pages/BookingPage";
import ContactPage from "@/pages/ContactPage";
import GalleryPage from "@/pages/GalleryPage";
import ReviewsPage from "@/pages/ReviewsPage";
import { BlogListPage, BlogPostPage } from "@/pages/BlogPages";
import { LoginPage, RegisterPage } from "@/pages/AuthPages";
import { PaymentSuccessPage, PaymentCancelPage } from "@/pages/PaymentPages";
import AccountPage from "@/pages/AccountPage";
import AdminPage from "@/pages/AdminPage";
import AuthCallback from "@/pages/AuthCallback";
import BundlesPage from "@/pages/BundlesPage";
import BundleDetailPage from "@/pages/BundleDetailPage";

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <CurrencyProvider>
          <div className="App">
            <Navbar />
            <Toaster richColors position="top-right" />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/packages" element={<PackagesPage />} />
              <Route path="/packages/:slug" element={<PackageDetailPage />} />
              <Route path="/bundles" element={<BundlesPage />} />
              <Route path="/bundles/:slug" element={<BundleDetailPage />} />
              <Route path="/book/bundle/:slug" element={<BookingPage />} />
              <Route path="/destinations" element={<PackagesPage />} />
              <Route path="/group-tours" element={<PackagesPage forceCategory="Group" />} />
              <Route path="/honeymoon" element={<PackagesPage forceCategory="Honeymoon" />} />
              <Route path="/corporate" element={<PackagesPage forceCategory="Corporate" />} />
              <Route path="/book/:slug" element={<BookingPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/blog" element={<BlogListPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/payment/cancel" element={<PaymentCancelPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
            </Routes>
            <Footer />
            <FloatingActions />
          </div>
          </CurrencyProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}
